import { put } from 'redux-saga/effects';
import API from '@utils/api';
import ClientActions from './ClientRedux';
import logger from '@utils/logger';

export function* fetchClient(actions) {
  const { clientId } = actions;
  yield put(ClientActions.setClientLoading(true));

  let clientInfo;

  try {
    const { result } = yield API.fetchClient(clientId);
    const { result: complaints } = yield API.fetchNextCleanNotes(clientId);
    const complaint = complaints[0] ? complaints[0].complaint : '';
    clientInfo = { ...result, complaint };
  } catch (err) {
    logger.error('err: ', err);
  }

  if (clientInfo) {
    let propertyInfo = {};
    const { propertyID: propertyId } = clientInfo;
    if (propertyId) {
      try {
        const { result } = yield API.fetchProperty(propertyId);
        if (result) {
          propertyInfo = result;
        }
      } catch (err) {
        logger.error('err: ', err);
      }
    }

    yield put(
      ClientActions.setClientData({
        ...clientInfo,
        propertyInfo
      })
    );
  }

  yield put(ClientActions.setClientLoading(false));
}
